import src from "IMAGE";
export default { src, width: 327, height: 97, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ABEJBhIgEQ0qBgcOGgUGDhkPCAgXGgsEFhYJAxILBQIJAAkFBg8ZDxEsCgwZLgoMGzEcDw8pORgIMDUXCCsUCAMQhuAEpz2h/doAAAAASUVORK5CYII="};
